import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { submitMessage } from 'LiveBoard/modules/cta'
import { FormDialogContainer } from '../FormDialog'
import SendMessage from './SendMessage'
import { CTA_FORM_NAMES } from '../constants'

const SendMessageContainer = ({
  config,
  onDone,
  area,
  submitMessage,
  initialValues
}) => (
  <FormDialogContainer
    area={area}
    form={CTA_FORM_NAMES.sendMessage}
    config={config}
    onSubmit={submitMessage}
    onDone={onDone}
    initialValues={initialValues} >
    <SendMessage />
  </FormDialogContainer>
)

SendMessageContainer.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  submitMessage: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired
}

function mapStateToProps({ lead }) {
  return { initialValues: { email: lead.email, message: null } }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ submitMessage }, dispatch)
}

export default connect(
  mapStateToProps, 
  mapDispatchToProps
)(SendMessageContainer)
